"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddLink = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*
    Author: Benjimin K. Aaron
    Description: A Hook for adding a link tag to an HTML document

    References: https://www.w3schools.com/tags/tag_link.asp
*/

// libraries

var useAddLink = function useAddLink(lObject) {
  React.useEffect(function () {
    // get the list of current link tags...
    var lTags = document.getElementsByTagName("link");

    // check for our tag in the list...
    if (lTags && lTags.length > 0) {
      for (var i = 0; i < lTags.length; i++) {
        // if you find it, return - we are done.
        if (lTags[i].getAttribute("rel") === lObject.rel && lTags[i].getAttribute("href") === lObject.href) return;
      }
    }

    // if it does not exists, create it...
    var lTag = document.createElement("link");
    Object.keys(lObject).map(function (key, mapIndex) {
      lTag.setAttribute("".concat(key), lObject[key]);
    });

    // get the document head 
    var head = document.getElementsByTagName("head")[0];

    // append the new tag to the head
    head.appendChild(lTag);
  }, []);
};
exports.useAddLink = useAddLink;